import { Spin, Table, Button, message, Modal, Input, Form } from "antd";
import React, { FC, Suspense, useEffect, useState } from "react";
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { useParams } from 'react-router-dom'
import { CSVLink } from "react-csv";
import { IActiveCustomer, IColumn, ICountry, ICustomerStatus, ISubChannel } from "../../reducer/ECommCustomers/_interfaces";
import { useDispatch, useSelector } from "react-redux";
import { addColumn, addUpdatedRow, clearData, clearError, clearSuccess, deleteColumn, deleteData, getColumns, loadCountries, loadData, loadDataForApproval, loadSubChannels, resetUpdateRows, setCustomersListData, updateData } from "../../actions/eComm/eCommCustomersActions";
import { CODE_HIERARHY, COLLABORATIVE_ADS, ONSITE_RETAIL_MEDIA, SHARED_DATA_WITH_CUSTOMERS, DIGITAL_TOOLS_OFFERED, COUNTRY, COUNTRY_CODE, DESCRIBE_PLANNED, CUSTOMER_NAME, CUSTOMER_URL, DATA_REPORTING_ESTIMATION, DEFAULT_COLUMNS, COLUMNS_FOR_EXPORT, DIRECT_INDIRECT, E_CUSTOMER_TYPE, ERED_ERETAIL, ERED_FSA, ERED_QC, ERED_QSR, FREQUENCY_DATA_SHARING, MARKET_SHARES, MEDIA_HOUSE, ORDERING_CHANNEL, PFP_IMPLEMENTATION, PRIORITY, PRODUCT_SUPPLIER, RETAIL_MEDIA, SAP_CODE, SELL_DATA_MESH, SELLES_DATA_SHARING, DIRECT_INDIRECT_COLUMNS, BOOL_DROPDOWN } from "./constants";
import EditableCell from "./EditableCell";
import DropDownCustom from "../../components/dropDownCustom";
import { Store } from "antd/es/form/interface";

import moment from 'moment-timezone';
import { access } from "../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const { v4 } = require("uuid");

interface ParamTypes {
    id: string;
}

const getNewItem = (id:string, country:{title:string, id:string}) => {
	return {
		id: id,
		[COUNTRY]: country.title,
		[COUNTRY_CODE]: country.id,
		[E_CUSTOMER_TYPE]: '',
		[CUSTOMER_NAME]: '',
		[PRODUCT_SUPPLIER]: '',
		[SAP_CODE]: '',
		[CODE_HIERARHY]: '',
		[DIRECT_INDIRECT]: false,
		[SELLES_DATA_SHARING]: '',
		[SELL_DATA_MESH]: '',
		[FREQUENCY_DATA_SHARING]: '',
		[DATA_REPORTING_ESTIMATION]: '',
		[PRIORITY]: '',
		[PFP_IMPLEMENTATION]: '',
		[DESCRIBE_PLANNED]: '',
		[ERED_ERETAIL]: '',
		[ERED_FSA]: '',
		[ERED_QC]: '',
		[ERED_QSR]: '',
		[MEDIA_HOUSE]: false,
		[MARKET_SHARES]: false,
		[CUSTOMER_URL]: '',
		[RETAIL_MEDIA]: false,
		[COLLABORATIVE_ADS]: false,
		[ONSITE_RETAIL_MEDIA]: false,
		[SHARED_DATA_WITH_CUSTOMERS]: '',
		[DIGITAL_TOOLS_OFFERED]: '',
		[ORDERING_CHANNEL]: '',
		status: 'created' as ICustomerStatus,
		created_at: '',
		is_approved: false,
		is_active: false,
		created_by: JSON.parse(localStorage.getItem('access_token') || '{}').user.id || ''
	}
}

const ECommerceCustomersPage:FC = (props) => {
	const [messageApi, contextHolder] = message.useMessage();
    const { id } = useParams<ParamTypes>();
    const dispatch = useDispatch();
    
	const [isAdmin, setIsAdmin] = React.useState(access.isAdmin(id))
	const [openColumnModal, setOpenColumnModal] = useState<boolean>(false);
	const [columnDeleteModal, setColumnDeleteModal] = useState<boolean>(false);
	const [selectedColumn, setSelectedColumn] = useState<number>(-1);
    const [selectedRows, setSelectedRows] = useState<(number|string)[]>([]);
    const [selectedCountry, setSelectedCountry] = useState<ICountry | null>(null);
    const [lastUpdateName, setLastUpdateName] = useState<string>('');
    const [lastUpdateDate, setLastUpdateDate] = useState<string>('');

    const countries = useSelector((state:any) => state.eCommCustomers.countries);
    const countriesLoading = useSelector((state:any) => state.eCommCustomers.countriesLoading);
    
	const subChannels = useSelector((state:any) => state.eCommCustomers.subChannels);
    const dataLoading = useSelector((state:any) => state.eCommCustomers.dataLoading);
    const subChannelsLoading = useSelector((state:any) => state.eCommCustomers.subChannelsLoading);
	const additionalColumns:IColumn[] = useSelector((state:any) => state.eCommCustomers.additionalColumns);
    const data = useSelector((state:any) => state.eCommCustomers.data);
    const updatedRows = useSelector((state:any) => state.eCommCustomers.updatedRows);
    const success = useSelector((state:any) => state.eCommCustomers.success);
    const error = useSelector((state:any) => state.eCommCustomers.error);

	const handleSave = (row:IActiveCustomer) => {
		const newData = [...data];
		const index = newData.findIndex((item) => row.id === item.id);
		const item = newData[index];
		newData.splice(index, 1, {
		  ...item,
		  ...row,
		});
		dispatch(addUpdatedRow({...row, status: typeof row.id === 'string'
			? 'created'
			: 'updated'
		}, updatedRows, newData));
	};

	const handleAdd = () => {
		if (selectedCountry) {
			const newRow = getNewItem(v4(), selectedCountry)
			dispatch(addUpdatedRow(newRow, updatedRows, [...data, newRow]))
		}
	};

	const handleDelete = () => {
		const tempSelectedSavedRows:(number|string)[] = [...selectedRows].filter((id) => typeof id !== 'string');
		const tempSelectedUnsavedRows:(number|string)[] = [...selectedRows].filter((id) => typeof id === 'string');
		
		const newRows = data.filter(({id}:IActiveCustomer) => typeof id === 'string' && !tempSelectedUnsavedRows.includes(id))
		const newRowsForDelete = data.filter(({id}:IActiveCustomer) => typeof id === 'string' && tempSelectedUnsavedRows.includes(id))
		if (tempSelectedSavedRows.length > 0 && selectedCountry) {
			dispatch(deleteData(id, tempSelectedSavedRows, selectedCountry.id, newRows))
		} else if (newRowsForDelete.length > 0) {
			dispatch(setCustomersListData(data.filter(({id}:IActiveCustomer) => !selectedRows.includes(id || -1))));
		}
	}

	const handleAddColumn = (values:Store) => {
		dispatch(addColumn(id, {
				data_index: values.columnName.replaceAll(' ', '_'),
				display_name: values.columnName,
			}, selectedCountry?.id));

		toggleColumnModal();
	}

	const toggleColumnDeleteModal = (columnId:number = -1) => {
		setColumnDeleteModal(!columnDeleteModal);
		setSelectedColumn(columnId);
	}

	const toggleColumnModal = () => {
		setOpenColumnModal(!openColumnModal)
	}

	const saveChanges = () => {
		if (selectedCountry) {
			dispatch(updateData(id, updatedRows, selectedCountry.id));
		}
	}
// additionalColumns
	const tableColumns:IColumn[] = [
		...DEFAULT_COLUMNS,
		...additionalColumns.map((a:any) => ({
			...a,
			title: () => <div style={{
				width: '100%',
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center'
			}}>
				{a.title}
				{isAdmin && (
					<Button
						type="ghost"
						onClick={() => toggleColumnDeleteModal(a.id)}
					>
						<FontAwesomeIcon
							style={{
								color: '#E61C2A'
							}}
							icon={faTrash}
						/>
					</Button>
				)}
			</div>
		}))
	].map((col:any) => {
		if (!col.editable) {
		  	return col;
		}
		return {
			...col,
			onCell: (record:any) => ({
				record,
				inputType: col.dataIndex === 'age' ? 'number' : 'text',
				editable: col.editable,
				dataIndex: col.dataIndex,
				title: col.title,
				handleSave,
			}),
		};
	})

    const initialDataLoad = async () => {
		dispatch(getColumns(id));
        dispatch(loadCountries(id));
		dispatch(loadSubChannels(id)); 	
    }

	const loadTableData = (country:ICountry | null) => {
		let params = {}
		if (country) {
			params = { country_id: country?.id }
			
			dispatch(loadData(id, 1, params));
            onSelectionChange([])
		}
	}


    useEffect(() => {
        setSelectedRows([]);
		if (data.length > 0) {
		const last = data[data.length - 1]
			setLastUpdateName(last.updated_by_email || '-')
			setLastUpdateDate(moment(last.updated_at).tz('CET').format("DD MMM YYYY HH:mm z"))
		}
    }, [data])

	useEffect(() => {
		loadTableData(selectedCountry)
		setLastUpdateName('')
		setLastUpdateDate('')
	}, [selectedCountry])

    useEffect(() => {
        initialDataLoad();
		return () => {
			dispatch(resetUpdateRows());
			dispatch(clearData());
		}
    }, []);

	useEffect(() => {
		success && messageApi.open({
			type: 'success',
			content: success,
			style: {zIndex: 10000, marginTop: 124},
			onClose: () => {
				dispatch(clearSuccess())
			}
		});
	}, [success, selectedCountry]);

	useEffect(() => {
		error && messageApi.open({
			type: 'error',
			content: error,
			style: {zIndex: 10000, marginTop: 124},
			onClose: () => {
				dispatch(clearError())
			}
		});
	}, [error]);

    const setDropDownValues =async (id:string, title:string ,valueType:string) => {
        if (valueType === "Country") {
			setSelectedCountry({id, title});
            setSelectedRows([]);
		}
    };
	

    const onSelectionChange = (newRows:any[]) => {
        setSelectedRows(newRows)
    }

    const rowSelection = {
        selectedRowKeys: selectedRows,
        onChange: onSelectionChange,
    }

	const components = {
		body: {
			row: EditableRow,
			cell: EditableCell,
		},
	};

    return (
        <Suspense fallback={<div>An error occured!</div>}>
            <div className="user-view-container">
                <div className="user-view-header row p-0 m-0 mb-4">
                    <div className="col-9 p-0 m-0 row">
                        <div className="col-5 p-0 m-0">
							<DropDownCustom
									title="Country"
									options={countries}
									loading={countriesLoading}
									setParentDropdownValue={setDropDownValues}
								/>
                        </div>
						<div className="col-7 p-0 m-0 my-auto user-view-added-at-container flex-1 d-flex">
							<div className="col-6 p-0 m-0 my-auto user-view-added-at-container d-flex align-items-center">
								<h3 className="user-view-text-header">Last Updated at:</h3>
								<h3 className="user-view-text-value">{lastUpdateDate}</h3>
							</div>

							<div className="col-6 p-0 m-0 my-auto user-view-added-at-container d-flex align-items-center">
								<h3 className="user-view-text-header">Last updated by:</h3>
								<h3 className="user-view-text-value">{lastUpdateName}</h3>
							</div>
						</div>
                    </div>

                    {/* <div className="col-2 p-0 m-0 my-auto"></div> */}

                    <div className="col-3 p-0 m-0 d-flex align-items-center justify-content-end">
						<CSVLink
							style={{ textDecoration: "none" }}
							filename={"Active customers list"}
							headers={[
								...COLUMNS_FOR_EXPORT,
								...tableColumns.map((col) => ({
									key: col.dataIndex,
									label: col.title
								}))
							]}
							data={
								data
									.filter((entry:IActiveCustomer) => entry.id && selectedRows.includes(entry.id))
									.map((entry:IActiveCustomer) => ({
										...entry,
										e_customer_type: subChannels.find((ch:any) => ch.value === entry.e_customer_type)?.label,
										collaborative_ads: BOOL_DROPDOWN.find((v) => v.value === entry.collaborative_ads)?.label,
										direct_indirect: DIRECT_INDIRECT_COLUMNS.find((v) => v.value === entry.direct_indirect)?.label,
										market_shares: BOOL_DROPDOWN.find((v) => v.value === entry.market_shares)?.label,
										media_house: BOOL_DROPDOWN.find((v) => v.value === entry.media_house)?.label,
										onsite_retail_media: BOOL_DROPDOWN.find((v) => v.value === entry.onsite_retail_media)?.label,
										retail_media: BOOL_DROPDOWN.find((v) => v.value === entry.retail_media)?.label,
									}))
								}
						>
							<Button
								type="primary"
								disabled={!selectedCountry || selectedRows.length === 0}
								className="brand-background"
							>
								{`Export record${selectedRows.length > 1 ? 's' : ''}`}
							</Button>
						</CSVLink>
						<Button
							disabled={!selectedCountry}
							onClick={handleAdd}
							type="primary"
							className="ms-1"
						>
							Add record
						</Button>
						<Button
							onClick={handleDelete}
							type="primary"
							disabled={!selectedCountry || selectedRows.length === 0}
							className="ms-1 brand-background"
						>
							{`Delete record${selectedRows.length > 1 ? 's' : ''}`}
						</Button>
						{isAdmin && <Button
							onClick={toggleColumnModal}
							type="primary"
							className="ms-1 brand-background"
						>
							Add column
						</Button>}
						<Button
							onClick={saveChanges}
							type="primary"
							className="ms-1 brand-background"
						>
							Save
						</Button>
                    </div>

                </div>
                <Spin tip="Loading" spinning={dataLoading || subChannelsLoading} size="large">
                    {/* MAIN TABLE */}
                    <Table
                        rowKey={'id'}
                        rowSelection={rowSelection}
                        columns={tableColumns}
                        size="small"
                        dataSource={data}
						pagination={{
							pageSize: 100
						}}
						components={components}
						rowClassName={() => 'editable-row'}
						bordered
						scroll={{
							x: tableColumns.reduce((a:number, {width}) => a + width, 0),
							y: 570
						}}
                    />
                </Spin>
				{contextHolder}

				

				<AddColumnModal
					handleAddColumn={handleAddColumn}
					toggleColumnModal={toggleColumnModal}
					openColumnModal={openColumnModal}
				/>

				<DeleteColumnModal
					selectedCountry={selectedCountry}
					open={columnDeleteModal}
					col={tableColumns.find(({id}) => id === selectedColumn)}
					toggleDeleteColumnModal={toggleColumnDeleteModal}
				/>
            </div>
        </Suspense>
    );
}

type IAddModal = {
	openColumnModal: boolean;
	handleAddColumn: (values:Store) => void;
	toggleColumnModal: () => void;
}

const AddColumnModal:FC<IAddModal> = ({ openColumnModal, handleAddColumn, toggleColumnModal }) => {
	const [form] = Form.useForm();

	const onOk = () => {
		form.submit()
	}

	useEffect(() => {
		form.resetFields()
	}, [openColumnModal]);

	const onClose = () => {
		form.resetFields()
		toggleColumnModal()
	}

	return (
		<Modal
			centered
			closable
			open={openColumnModal}
			title="Add column"
			onOk={onOk}
			onCancel={onClose}
			footer={[
				<Button key="back" onClick={onClose}>
					Cancel
				</Button>,
				<Button
					key="submit"
					type="primary"
					onClick={onOk}
					// disabled={form.getFieldsError().length > 0}
					className="ms-1 brand-background"
				>
					Submit
				</Button>
			]}
		>
			<Form
				form={form}
				layout="vertical"
				name="columnForm"
				onFinish={handleAddColumn}
			>
				<Form.Item
					name="columnName"
					label="Column name"
					shouldUpdate
					rules={[{
						required: true,
						message: 'Column name field is required'
					}]}
				>
					<Input />
				</Form.Item>
			</Form>
		</Modal>
	);
}

const DeleteColumnModal:FC<{col?:IColumn, open: boolean; toggleDeleteColumnModal: () => void; selectedCountry:ICountry | null}> = ({
	col,
	open,
	selectedCountry,
	toggleDeleteColumnModal
}) => {
    const { id } = useParams<ParamTypes>();
    const dispatch = useDispatch();
	
	console.log(col)

	const onOk = () => {
		if (col) {
			toggleDeleteColumnModal();
			dispatch(deleteColumn(id, col.id, selectedCountry?.id))
		}
	}

	return (
		<Modal
			centered
			closable
			open={open}
			title="Delete column"
			onOk={onOk}
			onCancel={toggleDeleteColumnModal}
			footer={[
				<Button key="back" onClick={toggleDeleteColumnModal}>
					Cancel
				</Button>,
				<Button
					key="submit"
					type="primary"
					onClick={onOk}
					// disabled={form.getFieldsError().length > 0}
					className="ms-1 brand-background"
				>
					Yes
				</Button>
			]}
		>
			<label>Are you sure you want to delete this column?</label>
		</Modal>
	);
}

export default ECommerceCustomersPage;

const EditableRow = ({ index, ...props }:any) => {
	return (
		<tr {...props} />
	);
};